import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';

/**
 * This component is nothing more than a bootstrap component. Facilitating the routing within the
 * single page application.
 */
@Component({
  selector: 'app-root',
  template: '<ion-app><ion-router-outlet /></ion-app>',
  imports: [IonApp, IonRouterOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainComponent {}
